// extracted by mini-css-extract-plugin
export default {"l_ProductInfoCardViewMode_main":"ProductInfoCardViewMode_l_ProductInfoCardViewMode_main__eB4+-"};